const action = type => (payload={}) => ({type, ...payload});

export const crud = type => ({
    request: (data) => action(type.REQUEST)(data),
    success: (data) => action(type.SUCCESS)(data),
    error:   (data) => action(type.ERROR)(data)
});

export default action;
